// ========================================================
// FAST HIT Website — Landing Page (Phase 2)
// Full conversion-focused sports-tech marketing page
// ========================================================

import { HeroSection } from '../components/landing/HeroSection';
import { LiveScorePreview } from '../components/landing/LiveScorePreview';
import { FeatureCards } from '../components/landing/FeatureCards';
import { HowItWorks } from '../components/landing/HowItWorks';
import { TournamentSpotlight } from '../components/landing/TournamentSpotlight';
import { AppDownloadSection } from '../components/landing/AppDownloadSection';
import { FaqSection } from '../components/landing/FaqSection';
import { usePageMetadata } from '../hooks/usePageMetadata';

export function LandingPage() {
  usePageMetadata({
    title: 'FAST HIT — Real-Time Cricket Scoring & Tournament Platform',
    description:
      'Live cricket scores, ball-by-ball updates, player profiles, and tournament management for local leagues and clubs across Tamil Nadu.',
    canonicalPath: '/',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'SportsOrganization',
      name: 'FAST HIT Cricket',
      url: 'https://fasthit.in',
      logo: 'https://fasthit.in/logo.png',
      description: 'Real-time cricket live scoring and tournament management ecosystem.',
    },
  });

  return (
    <div className="landing-page">
      {/* 1. Hero with Live Scorecard Showcase */}
      <HeroSection />

      {/* 3. Live-Score Preview (Real Matches or Honest Demo) */}
      <LiveScorePreview />

      {/* 4. Core Features Grid */}
      <FeatureCards />

      {/* 5. How It Works 4-Step Progression */}
      <HowItWorks />

      {/* 6. Tournament Spotlight */}
      <TournamentSpotlight />

      {/* 7. App Download & Mobile Experience */}
      <AppDownloadSection />

      {/* 8. Frequently Asked Questions */}
      <FaqSection />
    </div>
  );
}

export default LandingPage;
